import { Component } from '@angular/core';

@Component({
  selector: 'app-liste-biens',
  templateUrl: './liste-biens.component.html',
  styleUrls: ['./liste-biens.component.scss']
})
export class ListeBiensComponent {

}
